import { useState } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'

import * as S from './styled'
import { Footer } from '../../components/Footer'
import { Image } from '../../components/Image'
import Document from '../../components/Document'

const getLabelDocument = occupation => {
  if (occupation === 'architect') {
    return 'Número do CAU'
  }

  if (occupation === 'engineer') {
    return 'Número do CREA'
  }

  if (occupation === 'decorator') {
    return 'Número do ABD'
  }

  return 'Número do documento de classe'
}

const Form = ({ occupation, onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false)
  const [image, setImage] = useState()
  const { handleSubmit, register, ...propsForm } = useForm({
    mode: 'onChange',
    defaultValues: {
      document: '',
      image: ''
    }
  })

  const generateDataforSubmit = async data => {
    const dataSend = new FormData()
    dataSend.append('id', data.document)
    dataSend.append('picture', image, data.image)

    setLoading(true)
    await onSubmit(dataSend)
    setLoading(false)
  }

  const isCharactersRepeated = /(\d)\1{5,}/i
  const containStrangeCharacters = /[^a-zA-Z0-9\-.]+/i
  const isSequential = /(0?123456789|9876543210?)/i
  const containsUpTo13Characters = /[a-zA-Z0-9\-.]{3,13}/i

  return (
    <form onSubmit={handleSubmit(generateDataforSubmit)} data-cy="document-pro-form" >
      <S.Wrapper>
        <Document
          label={getLabelDocument(occupation)}
          ref={register({
            required: true,
            maxLength: 13,
            validate: value => {
              if (isCharactersRepeated.exec(value)) {
                return false
              }

              if (containStrangeCharacters.exec(value)) {
                return false
              }

              if (isSequential.exec(value)) {
                return false
              }

              return containsUpTo13Characters.exec(value)
            }
          })}
          {...propsForm}
        />
        <Image
          label="Foto do documento de classe"
          setImage={setImage}
          ref={register({
            required: true,
            pattern: /\.(png|jpe?g)$/i
          })}
          {...propsForm}
        />
      </S.Wrapper>
      <S.Wrapper>
        <S.Message>
          É necessário a validação do documento para ter acesso exclusivo a área
          profissional do Programa de Fidelidade da Leroy Merlin. Após o envio,
          a aprovação ocorre em até 4 dias úteis. Você também pode enviar o
          documento posteriormente.
        </S.Message>
      </S.Wrapper>
      <Footer onCancel={onCancel} loading={loading} />
    </form>
  )
}

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func
}

export default Form
